module.exports = __webpack_public_path__ + "media/images/icon_nega2-09ad6a4d2da919c9e7a9499ddbdb5790.svg";